export enum UserRole {
  rootAdmin = 0,
  admin = 1,
  insitute = 2,
  employee = 3,
  basicUser = 4
}